module.exports = __webpack_public_path__ + "assets/5eeda262d60499409c0cf8865d9d619c.mp4";